export const SERVICE_REQUEST_STATUS_COLORS = {
  open: "green",
  processing: "blue",
  closed: "default",
};

export const SERVICE_REQUEST_PRIORITIES = ["Urgent", "Important", "Low"];

export const normalizeServiceRequestResponse = (response) => {
  const payload = response?.data || {};
  if (Array.isArray(payload)) {
    return { rows: payload, total: payload.length };
  }
  return {
    rows: payload.results || [],
    total: payload.count || 0,
  };
};
